import React from 'react';
import { retryMsg } from '../../../../utils/const';
import Config from '../../../../config/Config';
import { connect } from 'react-redux';
import PermitDesktopInstruction  from './PermitDesktopInstruction';
import  PermitMobileInstruction from './PermitMobileInstruction';
const RecordInstruction = ({
    isMicPermitted,
    isFireFox,
    resetCounter,
}) => (
    <span>
    {
        isMicPermitted ?
            (resetCounter < 3 && resetCounter > -1  ?
                 <div style={{fontSize:"12px", color:"#716e6e"}}>
                     Tap <i className="recordInstructionPlay fa fa-play"/> to listen to your recording. 
                     {(resetCounter > 0 )&&     <span>Tap <i className="vjs-icon-audio-perm recordInstructionMic" /> again to re-record </span>}
                    <br />                
                    {retryMsg[resetCounter]}
                </div>   : resetCounter === 3 &&
                //    <div style={{fontSize:"12px", color:"#716e6e"}}>
                //         Click <i className="vjs-icon-audio-perm recordInstructionMic" /> button to record. 
                //         Click <i className="vjs-icon-record-stop recordInstructionStop" /> when finished.
                //         <br />                
                //         {retryMsg[resetCounter]}
                //     </div>
                <div className='resetCounter-Note' style={{fontSize:"12px", color:"#716e6e"}}>{retryMsg[resetCounter]}</div>
               ) : 
            (
                <span>
                   <i className="fa fa-microphone-slash microphone-allow-icon"></i>
                   { isFireFox ?
                   <div> This test requires your microphone permission. To enable microphone access please click the reload button <img src={Config.ASSETSPATH+'img/icon_browser_reload.png'} alt='reloadIcon' style={{height:'20px' , width: '20px'}}/> of the browser at the top and click 'Allow' in the permission prompt that appears.</div> :
                   /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? <PermitMobileInstruction/> : <PermitDesktopInstruction/>
                    }
                </span>
            )
    }
    </span>)


const mapStateToProps = (state) => {
    const {
        isFireFox,
        isMicPermitted
    } = state.rootReducer.testPageDetails;

    return {
        isFireFox,
        isMicPermitted,
    }
}



export default connect(mapStateToProps)(RecordInstruction);